// src/services/apiService.ts

import httpClient from "../utils/http-client";

class ApiService {
  // Generic GET Request
  async get<T>(url: string, params?: object): Promise<T> {
    const response = await httpClient.get<T>(url, { params });
    return response.data;
  }

  // Generic POST Request
  async post<T>(url: string, data: object): Promise<T> {
    const response = await httpClient.post<T>(url, data);
    return response.data;
  }

  // Generic PUT Request
  async put<T>(url: string, data: object): Promise<T> {
    const response = await httpClient.put<T>(url, data);
    return response.data;
  }

  // Generic DELETE Request
  async delete<T>(url: string): Promise<T> {
    const response = await httpClient.delete<T>(url);
    return response.data;
  }
}

export const apiService = new ApiService();
